/**
 * @param {string} value
 * @returns {string}
 */
export function getCurrentFilterSegment(value) {
  return (value.match(/[^,]*[^,]$/i) || [''])[0].trim();
}

/**
 * @param {string} value
 * @param {(value: string) => true|string|boolean|undefined} [validateFilterValue]
 * @returns {string|null}
 */
export default function resolveFilterValidation(value, validateFilterValue) {
  if (!validateFilterValue) {
    return null;
  }

  const segment = getCurrentFilterSegment(value);
  if (!segment) {
    return null;
  }

  const result = validateFilterValue(value);
  if (result === true) {
    return null;
  }

  return typeof result === 'string' ? result : null;
}
